import PropTypes from 'prop-types';

export const GET_PERSON = 'GET_PERSON';
export const GET_PERSON_START = `${GET_PERSON}_START`;
export const GET_PERSON_SUCCESS = `${GET_PERSON}_SUCCESS`;
export const GET_PERSON_FAIL = `${GET_PERSON}_FAIL`;

export const GET_PERMISSIONS = 'GET_PERMISSIONS';
export const GET_PERMISSIONS_START = `${GET_PERMISSIONS}_START`;
export const GET_PERMISSIONS_SUCCESS = `${GET_PERMISSIONS}_SUCCESS`;
export const GET_PERMISSIONS_FAIL = `${GET_PERMISSIONS}_FAIL`;

// Actions triggered from GWT
export const UPDATE_CUSTOM_TIME_ZONE_REVERSE_LOOKUP =
  'UPDATE_CUSTOM_TIME_ZONE_REVERSE_LOOKUP';
export const UPDATE_LOGGED_IN_USER_ID = 'UPDATE_LOGGED_IN_USER_ID';
export const UPDATE_USER_PREFERENCES = 'UPDATE_USER_PREFERENCES';
export const UPDATE_HAS_SCHEDULED_MESSAGES = 'UPDATE_HAS_SCHEDULED_MESSAGES';
export const UPDATE_USER_TIMEZONE = 'UPDATE_USER_TIMEZONE';
export const VIEWING_USER_PROFILE = 'VIEWING_USER_PROFILE';
export const UPDATE_PRICING_URL = 'UPDATE_PRICING_URL';

// Currently there are 346 total permissions so this will get all of them
export const PERMISSION_LIMIT = 1000;

export const userProfileProptype = PropTypes.shape({
  id: PropTypes.string,
  targetName: PropTypes.string,
  recipientType: PropTypes.string,
  externallyOwned: PropTypes.bool,
  links: PropTypes.object,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  language: PropTypes.string,
  timezone: PropTypes.string,
  webLogin: PropTypes.string,
  site: PropTypes.object,
  status: PropTypes.string,
  permissions: PropTypes.arrayOf(PropTypes.object),
});

/**
 * Function to return input uri
 * @param  {string} uri
 * @return {string} uri
 */
export function overrideDefaultEncodingFunc(uri) {
  return uri;
}

export function getPerson(id) {
  return {
    type: GET_PERSON,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/people/${encodeURIComponent(
        id,
      )}?embed=roles,rolePermissions`,
      method: 'get',
      customUriWithParamsGenerator: overrideDefaultEncodingFunc,
    },
  };
}

export function getPermissions(id) {
  return {
    type: GET_PERMISSIONS,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/people/${id}/permissions?limit=${PERMISSION_LIMIT}`,
      method: 'get',
    },
  };
}

export function updateLoggedInUserId(loggedInUserId) {
  return {
    type: UPDATE_LOGGED_IN_USER_ID,
    payload: { loggedInUserId },
  };
}
